export const PAGE_API = 'pageApi';
export const REFRESH_PAGE_API = 'refreshPageApi';
export const SHOW_COMPONENT_PAGE_API = 'showComponentPageApi';
export const HIDE_COMPONENT_PAGE_API = 'hideComponentPageApi';
export const USER_ROLE_API = 'userRoleApi';
export const EMAIL_TEMPLATE_API = 'emailTemplateApi';
export const PAGE_COMPONENT = 'pageComponent';
export const REFRESH_PAGE_COMPONENT = 'refreshPageComponent';
export const RESET_PASSWORD_PAGE_COMPONENT = 'resetPassowordPageComponent';
export const PAGE_FORM_COMPONENT = 'pageFormComponent';
export const PAGE_FORM_COMPONENTS = 'pageFormComponents';
export const SHOW_PAGE_COMPONENTS = 'showPageComponents';
export const HIDE_PAGE_COMPONENTS = 'hidePageComponents';
export const MODAL_API = 'modalApi';
export const FLOATING_MODAL_API = 'floatingModalApi';
export const SUB_PAGE_API = 'subPageApi';
export const PDF_TEMPLATE_API = 'pdfTemplateApi';
export const PAGE_SUB_PAGE_COMPONENTS_API = 'pageSubPageComponentApi';
export const CUSTOM_COMPONENT_API = 'customComponentApi';
export const SOURCE_API = 'sourceApi';
export const SOURCE_PAGE = 'sourcePage';
export const SOURCE_PAGE_API = 'sourcePageApi';
export const PAGE_CUSTOM_COMPONENT_COMPONENTS_API = 'pageCustomComponentComponentApi';
export const DS_REST_API = 'dsRestApi';
export const DS_DATABASE = 'dsDatabase';
export const DS_GOOGLE_SHEET = 'dsGoogleSheet';
export const DS_AIRTABLE = 'dsAirtable';
export const DS_FIREBASE_CLOUD_FIRESTOE = 'dsFirebaseCloudFirestore';
export const DS_FIREBASE_FUNCTION = 'dsFirebaseFunction';
export const DS_FIREBASE_REALTIME_DATABASE = 'dsFirebaseRealtimeDatabase';
export const DS_EXTERNAL_API = 'dsExternalApi';
export const DS_ZAPS = 'dsZaps';
export const DS_CHAT_GPT = 'dsChatGPT';
export const DS_SUPABASE = 'dsSupabase';
export const DS_DIRECTUS = 'dsDirectus';
export const DS_APPWRITE = 'dsAppwrite';
export const DS_XANO = 'dsXano';
export const DS_API_COLLECTION_FIELDS = 'dsApiCollectionFields';
export const COLLECTION_API = 'collectionApi';
export const COLLECTION_CONSTRUCTOR_API = 'collectionConstructorApi';
export const TENANT_CONSTRUCTOR_API = 'tenantConstructorApi';
export const COLLECTION_REQUEST_API = 'collectionRequestApi';
export const WAIT_TIME_OPTIONS_IN_SECOND = 'waitTimeOptionsInSecond';
export const COLLECTION_FIELD_API = 'collectionFieldApi';
export const REDIRECT_FROM_OPTIONS = 'redirectFromOptions';
export const PAGE_COLLECTION_FORM_COMPONENT = 'pageCollectionFormComponent';
export const REFRESH_PAGE = 'refreshPage';
export const SHOW_COMPONENT_PAGE = 'showComponentPage';
export const COMPONENT_PAGE = 'componentPage';
export const HIDE_COMPONENT_PAGE = 'hideComponentPage';
export const PAGE = 'page';
export const FORM_PAGE = 'formPage';
export const DEFAULT_USER_COLLECTION = 'user';
export const LOCALIZATION_API = 'localizationApi';
export const MULTI_TENANT_API = 'multiTenantApi';
export const TOOLTIP_API = 'toolTipApi';
export const TOOLTIP_POSITION = 'toolTipPosition';
export const TOOLTIPS_THEME = 'toolTipTheme';
export const TOOLTIPS_ANIMATION = 'toolTipAnimation';
export const TOOLTIPS_FOLLOW_CURSOR = 'toolTipFollowCursor';
export const SMS_TEMPLATE_API = 'smsTemplateApi';
export const description = `Go to the Delete Permissions in Settings and Enable it.`;
export const AGREEMENT_TEMPLATE_API = 'agreementTemplateApi';
export const AGREEMENT_TEMPLATE_PDF_API = 'agreementTemplatePdfApi';
export const TYPESENSE_SEARCH_COLLECTION_API = 'typesenseSearchCollectionApi';
export const GET_CUSTOM_FUNCTION_FROM_API = 'getCustomFunctionFromApi';
export const EMAIL_SERVICE_PLUGIN_API = 'emailServicePluginApi';
export const COLLECTION_META_DATA_MAPPING_API = 'collectionMetaDataMappingApi';
export const GET_ITEM_ID_FROM_API = 'getItemIdFromApi';
export const SMS_SERVICE_PLUGIN_API = 'smsServicePluginApi';
export const LOGOUT_ITEM_API = 'logoutItemApi';
export const PAGE_SIGN_PAD_COMPONENTS_API = 'pageSignPadComponentApi';

export const waitTimeOptions = [
  { value: '', label: '-Select One-' },
  { value: 5, label: '5 Seconds' },
  { value: 10, label: '10 Seconds' },
  { value: 15, label: '15 Seconds' },
  { value: 30, label: '30 Seconds' },
  { value: 45, label: '45 Seconds' },
  { value: 60, label: '1 Minute' },
];

export const redirectOptions = [
  { value: 'SESSION', label: 'Session Value (Previous Action Response)' },
  { value: 'CUSTOM_URL', label: 'Custom URL' },
  { value: 'FORM_SUBMIT_SESSION_VALUE', label: 'Form Submit Through Session Value' },
  {
    value: 'BASE64_FORM_SUBMIT_SESSION_VALUE',
    label: 'Base64 Form Submit Through Session Value',
  },
  { value: 'BROWSER_STORAGE', label: 'Browser Storage' },
];

export const refreshShowHideOpts = [COMPONENT_PAGE, PAGE, FORM_PAGE, SHOW_COMPONENT_PAGE_API];

export const dropdownSourceOpts = [
  PAGE,
  FORM_PAGE,
  SOURCE_PAGE_API,
  SHOW_COMPONENT_PAGE,
  HIDE_COMPONENT_PAGE,
  SHOW_COMPONENT_PAGE_API,
  HIDE_COMPONENT_PAGE_API,
  REFRESH_PAGE,
  REFRESH_PAGE_API,
];

export const collectionRequestOptions = [
  { value: 'Secured', label: 'Secured (LoggedIn User)' },
  { value: 'Open', label: 'Open (Non-LoggedIn User)' },
];

export const sendDataToApiOptions = [
  'sendDataToExternalApi',
  'sendDataToExternalApiAndAuthorize',
  'sendDataToExternalApiAndFileDownload',
];

export const sourceOptions = [
  { value: 'PAGE', label: 'Page' },
  { value: 'MODAL', label: 'Modal' },
  { value: 'SUB_PAGE', label: 'Sub Page' },
];

export const toolTipPositionOptions = [
  { value: 'top', label: 'Top' },
  { value: 'top-start', label: 'Top Start' },
  { value: 'top-end', label: 'Top End' },
  { value: 'right', label: 'Right' },
  { value: 'right-start', label: 'Right Start' },
  { value: 'right-end', label: 'Right End' },
  { value: 'bottom', label: 'Bottom' },
  { value: 'bottom-start', label: 'Bottom Start' },
  { value: 'bottom-end', label: 'Bottom End' },
  { value: 'left', label: 'Left' },
  { value: 'left-start', label: 'Left Start' },
  { value: 'left-end', label: 'Left End' },
  { value: 'auto', label: 'Auto' },
  { value: 'auto-start', label: 'Auto Start' },
  { value: 'auto-end', label: 'Auto End' },
];

export const toolTipsThemeOptions = [
  { value: 'light', label: 'Light' },
  { value: 'light-border', label: 'Light Border' },
  { value: 'material', label: 'Material' },
  { value: 'translucent', label: 'Translucent' },
];

export const toolTipsAnimationOptions = [
  { value: 'shift-away', label: 'Shift Away' },
  { value: 'shift-away-subtle', label: 'Shift Away Subtle' },
  { value: 'shift-away-extreme', label: 'Shift Away Extreme' },
  { value: 'shift-toward', label: 'Shift Toward' },
  { value: 'shift-toward-subtle', label: 'Shift Toward Subtle' },
  { value: 'shift-toward-extreme', label: 'Shift Toward Extreme' },
  { value: 'scale', label: 'Scale' },
  { value: 'scale-subtle', label: 'Scale Subtle' },
  { value: 'scale-extreme', label: 'Scale Extreme' },
  { value: 'perspective', label: 'Perspective' },
  { value: 'perspective-subtle', label: 'Perspective Subtle' },
  { value: 'perspective-extreme', label: 'Perspective Extreme' },
];

export const toolTipsFollowCursorOptions = [
  { value: false, label: 'False' },
  { value: 'horizontal', label: 'Horizontal' },
  { value: 'vertical', label: 'Vertical' },
  { value: true, label: 'Both' },
  { value: 'initial', label: 'Initial' },
];

const getItemOption = [
  { value: '', label: '- Select One -' },
  { value: 'default', label: `Current Item ID (Default)` },
  { value: 'sendPreviousStepParentCollectionId', label: 'Item ID from Previous Step' },
  { value: 'sendCurrentPageItemId', label: 'Item ID of Current Page' },
];

export const getItemIdFromOptions = [
  ...getItemOption,
  {
    value: 'sendBSLItemId',
    label: 'Item ID from Browser Storage Location',
  },
];

export const getItemIdForLogoutOptions = [
  ...getItemOption,
  { value: 'currentUser', label: `Current LoggedIn User.` },
];

export const browserStorageAndConsoleArgs = [
  'passPreviousActionFormData',
  'formDataSessionKey',
  'formDataBrowserStorageLocation',
  'passPreviousActionResponse',
  'responseDataSessionKey',
  'responseDataSessionStorageLocation',
  'enableConsoleLog',
  'startConsoleLog',
  'endConsoleLog',
];

export const formDataArgs = [
  {
    name: 'passPreviousActionFormData',
    label: 'Save Form Submission Data In Browser Storage',
    type: 'boolean',
    value: '',
  },
  {
    name: 'formDataSessionKey',
    label: 'Form Data Session Key',
    type: 'text',
    value: '',
  },
  {
    name: 'formDataBrowserStorageLocation',
    label: 'Session Storage Location (Optional)',
    type: 'dropdown',
    optionsType: 'browserStorageLocationOptions',
    options: [],
    value: 'SESSION_STORAGE',
  },
];

export const browserDataArgs = [
  {
    name: 'passPreviousActionResponse',
    label: 'Save Response Data In Browser Storage',
    type: 'boolean',
    value: '',
  },
  {
    name: 'responseDataSessionKey',
    label: 'Response Data Session Key',
    type: 'text',
    value: '',
  },
  {
    name: 'responseDataSessionStorageLocation',
    label: 'Session Storage Location (Optional)',
    type: 'dropdown',
    optionsType: 'browserStorageLocationOptions',
    options: [],
    value: 'SESSION_STORAGE',
  },
];

export const browserStorageArgsConfig = [...formDataArgs, ...browserDataArgs];

export const consoleLogArgsConfig = [
  {
    name: 'enableConsoleLog',
    label: 'Enable Console Logs',
    type: 'boolean',
    value: '',
  },
  {
    name: 'startConsoleLog',
    label: 'Log message on entry',
    type: 'text',
    value: '',
  },
  {
    name: 'endConsoleLog',
    label: 'Log message on exit',
    type: 'text',
    value: '',
  },
];

export const browserStorageAndConsoleArgsConfig = [
  ...browserStorageArgsConfig,
  ...consoleLogArgsConfig,
];

export const alertMessagesArgsConfig = [
  {
    name: 'successMessage',
    label: 'Success Message (Optional)',
    type: 'text',
    value: '',
    optional: true,
  },
  {
    name: 'errorMessage',
    label: 'Error Message (Optional)',
    type: 'text',
    value: '',
    optional: true,
  },
];

export const getItemIdFromArgsConfig = [
  {
    name: 'getItemIdFrom',
    label: 'Get Item Id From',
    type: 'dropdown',
    optionsType: 'getItemIdFromApi',
    value: '',
  },
  {
    name: 'browserStorageLocation',
    label: 'Session Storage Location (Optional)',
    type: 'browserStorageLocation',
    optionsType: 'browserStorageLocationOptionsApi',
    options: [],
    value: 'SESSION_STORAGE',
  },
  {
    name: 'browserStorageItemIdPath',
    label: 'Browser Storage Key',
    type: 'text',
    placeholder: 'Item Id Path (ex. sessionKey.uuid)',
    value: '',
  },
];

export const redirectUrlArgsConfig = [
  {
    name: 'successRedirectUrl',
    label: 'Select Success Page',
    type: 'dropdown',
    optionsType: 'pageApi',
    options: [],
    value: '',
  },
  {
    name: 'errorRedirectUrl',
    label: 'Select Error Page',
    type: 'dropdown',
    optionsType: 'pageApi',
    options: [],
    value: '',
  },
];

export const collectionArgsConfig = {
  name: 'collection',
  label: 'Select Collection',
  type: 'dropdown',
  optionsType: 'collectionApi',
  options: [],
  value: '',
};

export const collectionFieldArgsConfig = ({
  name = 'field',
  label = 'Select Field',
  multi = false,
  optional = false,
  optionsType = 'collectionFieldApi',
}) => {
  return {
    name,
    label,
    type: 'dropdown',
    multi,
    optionsType,
    options: [],
    value: '',
    optional,
  };
};

export const retainUrlParamsArgsConfig = {
  name: 'retainUrlParams',
  label: 'Retain URL Path, Query & Hash',
  type: 'boolean',
  value: false,
};

export const isNonPersistentArgsConfig = [
  {
    name: 'isNonPersistent',
    label: 'Non-Persistent Item',
    type: 'boolean',
    value: '',
  },
];

export const fetchEventsTillArgsConfig = {
  name: 'fetchEventsTill',
  label: 'Fetch Events Till',
  type: 'dropdown',
  options: [
    { label: 'Next 1 Week', value: '1w' },
    { label: 'Next 2 Weeks', value: '2w' },
    { label: 'Next 1 Month', value: '1m' },
    { label: 'Next 3 Months', value: '3m' },
    { label: 'Next 6 Months', value: '6m' },
    { label: 'Next 1 Year', value: '1y' },
    { label: 'All Future Events', value: 'all' },
  ],
  optionsType: 'fetchEventsTillApi',
  value: '',
};

export const fetchOnlyFutureEventsArgsConfig = {
  name: 'fetchOnlyFutureEvents',
  label: 'Fetch Only Future Events',
  type: 'boolean',
  value: '',
};

export const googleCalendarCollectionArgsConfig = {
  name: 'collection',
  label: 'Select Collection',
  type: 'dropdown',
  optionsType: 'googleCalendarCollectionApi',
  options: [],
  value: '',
};

export const sendMeetingNotificationsArgsConfig = {
  name: 'sendNotification',
  label: 'Send Notification to the attendees',
  type: 'boolean',
  value: '',
};

export const SEND_ITEM_ID_FROM_OPTIONS_DESC = `
  <ul>
    <li>
      <b>Current Item ID -</b> Send the recently created or updated Collection
      Item ID, to the next page.
    </li>
    <li>
      <b>Item ID from Previous Step -</b> Send the Collection's Item ID, which was
      recorded in the previous step, to the next page.
    </li>
    <li>
      <b>Item ID of Current Page -</b> Send the Collection's Item ID from the
      Current Page URL, to the next page.
    </li>
    <li>
      <b>Current LoggedIn User ID -</b> Send the Current LoggedIn User ID, to the
      next page.
    </li>
    <li>
      <b>Link/Button Item ID -</b> Send the target element (Link/Button)
      Collection Item ID, to the next page.
    </li>
    <li>
      <b>Item ID of Current Page Reference Item -</b> Send the Collection's Item
      ID of Current Page Reference Item, to the next page.
    </li>
    <li>
      <b>Item ID from Browser Storage Location -</b> Send the Collection's Item ID
      from the Browser storage location (Default: Session Storage), to the
      next page.
    </li>
  </ul>
    `;

export const sendItemIdFromOptions = () => {
  let options = [
    { value: '', label: '- Select One -' },
    { value: 'sendCurrentObjectID', label: `Current Item ID` },
    { value: 'sendPreviousStepParentCollectionId', label: `Item ID from Previous Step` },
    { value: 'sendCurrentPageItemId', label: `Item ID of Current Page` },
    { value: 'sendCurrentUserId', label: `Current LoggedIn User ID` },
    { value: 'sendTargetItemID', label: `Link/Button Item ID` },
    {
      value: 'sendCurrentPageReferenceItemId',
      label: `Item ID of Current Page Reference Item`,
    },
    {
      value: 'sendBSLItemId',
      label: `Item ID from Browser Storage Location`,
    },
  ];
  return options;
};

export const onlyRedirectArgsConfig = {
  name: 'redirectUrl',
  label: 'Select Page',
  type: 'dropdown',
  optionsType: 'pageApi',
  options: [],
  value: '',
};

export const boldSignDeliveryArgsConfig = [
  collectionFieldArgsConfig({ name: 'nameField', label: 'Name Field' }),
  {
    name: 'deliveryMode',
    label: 'Delivery Mode',
    type: 'dropdown',
    optionsType: 'boldSignDeliveryMethod',
    options: [
      { label: 'Email', value: 'Email' },
      { label: 'SMS', value: 'SMS' },
      { label: 'Both', value: 'EmailAndSMS' },
    ],
    value: 'Email',
  },
  collectionFieldArgsConfig({ name: 'boldSignEmailField', label: 'Email Field' }),
  collectionFieldArgsConfig({ name: 'boldSignPhoneNumberField', label: 'Phone Number Field' }),
];

export const expiryDaysArgsConfig = {
  name: 'expiryDays',
  label: 'Expiry Days',
  type: 'number',
  value: '',
};

export const otpAuthenticationTypeArgsConfig = {
  name: 'otpAuthenticationType',
  label: 'Select Authentication Type',
  type: 'dropdown',
  optionsType: 'otpAuthenticationType',
  options: [
    {
      label: 'Login',
      value: 'login',
    },
    {
      label: 'Sign Up',
      value: 'signUp',
    },
  ],
  value: 'login',
};

export const deliveryMethodServicePluginArgsConfig = (method = 'email') => {
  return {
    name: method === 'email' ? 'emailServicePlugin' : 'smsServicePlugin',
    label: method === 'email' ? 'Select Email Service Plugin' : 'Select SMS Service Plugin',
    type: 'dropdown',
    optionsType: method === 'email' ? 'emailServicePluginApi' : 'smsServicePluginApi',
    options: [],
    value: '',
  };
};

export const userRoleArgsConfig = ({ name = 'userRole', optionsType = 'userRoleApi' }) => {
  return {
    name,
    label: 'Select User Role',
    type: 'dropdown',
    optionsType,
    options: [],
    value: '',
  };
};

export const dataOperationTypeArgsConfig = {
  name: 'dataOperationType',
  label: 'Data Operation',
  type: 'dropdown',
  optionsType: 'dataOperationType',
  options: [
    {
      label: 'Save',
      value: 'save',
    },
    {
      label: 'Update',
      value: 'update',
    },
  ],
  value: 'save',
};
